import React from "react";

const STYLES = {
  Submitted: "bg-zinc-100 text-zinc-700 border-zinc-300",
  "In Review": "bg-orange-50 text-orange-700 border-orange-200",
  Quoted: "bg-blue-50 text-blue-700 border-blue-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Closed: "bg-zinc-900 text-white border-zinc-900",
  new: "bg-coral/10 text-coral border-coral/30",
  replied: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sent: "bg-blue-50 text-blue-700 border-blue-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  initiated: "bg-zinc-100 text-zinc-600 border-zinc-300",
};

export const StatusBadge = ({ status, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${STYLES[status] || "bg-zinc-100 text-zinc-700 border-zinc-300"}`}
  >
    {status}
  </span>
);

export default StatusBadge;
